import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"cross\">\n  <path fill-rule=\"evenodd\" d=\"M450.7,113.7a0.993,0.993,0,0,1-1.4,0l-2.308-2.308-2.313,2.312a0.992,0.992,0,0,1-1.4-1.4l2.312-2.313-2.312-2.312a0.992,0.992,0,0,1,1.4-1.4l2.313,2.312,2.308-2.308a0.992,0.992,0,1,1,1.4,1.4l-2.308,2.309,2.308,2.308a0.991,0.991,0,0,1,0,1.4\" transform=\"translate(-443 -106)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cross.svg
// module id = null
// module chunks = 